import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from '../environments/environment'; // adjust path if needed!

@Injectable({
  providedIn: 'root',
})
export class AppInsightsService {
  appInsights: ApplicationInsights;

  constructor() {
    this.appInsights = new ApplicationInsights({
      config: {
        connectionString: environment.appInsightsConnectionString,
        enableAutoRouteTracking: true,
      }
    });
    this.appInsights.loadAppInsights();
  }

  logInfo(message: string, properties?: { [key: string]: any }): void {
    this.appInsights.trackTrace({
      message: message,
      severityLevel: 1, // Info
      properties: properties
    });
  }

  logWarning(message: string, properties?: { [key: string]: any }): void {
    this.appInsights.trackTrace({
      message: message,
      severityLevel: 2, // Warning
      properties: properties
    });
  }

  logError(message: string, error?: any, properties?: { [key: string]: any }): void {
    this.appInsights.trackException({
      exception: error instanceof Error ? error : new Error(error ? JSON.stringify(error) : 'Unknown Error'),
      severityLevel: 3, // Error
      properties: {
        message,
        ...properties
      }
    });
  }

  logException(error: any, source: string, functionName: string) {
    this.appInsights.trackException({
      exception: error,
      severityLevel: 3
    });

    // Optionally include extra context
    this.appInsights.trackTrace({
      message: `Exception in ${functionName}`,
      severityLevel: 3,
      properties: {
        source,
        function: functionName,
        error: error?.message || 'Unknown error',
        stack: error?.stack || 'No stack'
      }
    });
  }
  
}

